// Social media links component
import React from 'react';
import { BsInstagram } from 'react-icons/bs';
import { FaLinkedin, FaGithub } from 'react-icons/fa';

const SocialMedia = () => {
  return (
    <div className='app__social'>
        <div>
          <a href="https://www.linkedin.com/in/patrick-ganhiwa-369aaa13a/" target="_blank" rel="noreferrer"><FaLinkedin /></a>
        </div>
        <div>
          <a href="https://github.com/Pats101" target="_blank" rel="noreferrer"><FaGithub /></a>
        </div>
        {process.env.REACT_APP_INSTAGRAM_URL && (
          <div>
            <a href={process.env.REACT_APP_INSTAGRAM_URL} target="_blank" rel="noopener noreferrer"><BsInstagram /></a>
          </div>
        )}
    </div>
  )
}

export default React.memo(SocialMedia)